(function() {
  // Tile markup is rendered by snippets/collection-content-tile.liquid into
  // <template>s; this script only places clones inside the Boost product grid
  // and re-places them whenever Boost re-renders (filter, sort, pagination).
  var container = document.getElementById('CollectionContentTiles');
  if (!container) return;

  var templates = Array.prototype.slice.call(
    container.querySelectorAll('template[data-collection-content-tile-template]')
  );
  if (templates.length === 0) return;

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var scheduled = false;
  var listObserver;

  templates.forEach(function(template) {
    if (template.dataset.lowRes) {
      console.warn('[PLP promo tile] Low-resolution image: ' + template.dataset.lowRes);
    }
  });

  function integerOr(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isInteger(parsed) ? parsed : fallback;
  }

  function isScheduledNow(template) {
    var now = Date.now() / 1000;
    var startsAt = integerOr(template.dataset.startsAt, null);
    var endsAt = integerOr(template.dataset.endsAt, null);
    if (startsAt !== null && now < startsAt) return false;
    if (endsAt !== null && now > endsAt) return false;
    return true;
  }

  function activeTiles() {
    var isMobile = mobileQuery.matches;
    return templates
      .filter(isScheduledNow)
      .map(function(template, order) {
        var position = isMobile
          ? integerOr(template.dataset.mobilePosition, integerOr(template.dataset.position, 3))
          : integerOr(template.dataset.position, 3);
        return { template: template, position: Math.max(1, position), order: order };
      })
      .sort(function(a, b) {
        return a.position - b.position || a.order - b.order;
      });
  }

  function createTile(template) {
    var tile = template.content.firstElementChild.cloneNode(true);

    if (tile.tagName === 'A') {
      tile.addEventListener('click', function(event) {
        // Keep Boost's delegated product-grid handler from cancelling this link.
        event.stopPropagation();
      });
    }

    var video = tile.querySelector('video');
    if (video && reducedMotionQuery.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    return tile;
  }

  function insertTiles() {
    scheduled = false;
    var list = document.querySelector('.boost-sd__product-list');
    if (!list) return;

    list.querySelectorAll('[data-collection-content-tile]').forEach(function(tile) {
      tile.remove();
    });

    var products = Array.prototype.slice.call(list.children).filter(function(child) {
      return child.classList.contains('boost-sd__product-item');
    });
    if (products.length === 0) return;

    var lastInsertedAfter = {};
    activeTiles().forEach(function(entry) {
      var index = Math.min(entry.position, products.length) - 1;
      var anchor = lastInsertedAfter[index] || products[index];
      var tile = createTile(entry.template);
      anchor.after(tile);
      lastInsertedAfter[index] = tile;
    });

    list.classList.add('boost-sd__product-list--with-content-tile');

    if (!listObserver) observeBoostRoot(document.getElementById('MainContent') || document.body);
  }

  function scheduleInsertion() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(insertTiles);
  }

  function tilesNeedPlacing() {
    var list = document.querySelector('.boost-sd__product-list');
    if (!list || !list.querySelector('.boost-sd__product-item')) return false;
    if (!list.classList.contains('boost-sd__product-list--with-content-tile')) return true;
    var placed = list.querySelectorAll('[data-collection-content-tile]').length;
    return placed !== activeTiles().length;
  }

  function observeBoostRoot(root) {
    if (!root) return;
    // Boost's client-side pagination replaces the whole .boost-sd__filter-product-list
    // root, so watch a stable ancestor and check the resulting state (grid class
    // and tile count) rather than the kind of mutation.
    listObserver = new MutationObserver(function() {
      if (tilesNeedPlacing()) scheduleInsertion();
    });
    listObserver.observe(root, { childList: true, subtree: true });
  }

  // Desktop and mobile can use different positions, so re-place on breakpoint changes.
  mobileQuery.addEventListener('change', scheduleInsertion);

  var pollCount = 0;
  var pollInterval = window.setInterval(function() {
    pollCount += 1;
    if (document.querySelector('.boost-sd__product-list .boost-sd__product-item')) {
      window.clearInterval(pollInterval);
      insertTiles();
    } else if (pollCount >= 60) {
      window.clearInterval(pollInterval);
    }
  }, 500);
})();
